import cx from "classnames";
import React, { FC, HTMLAttributes } from "react";

import * as classNames from "./MarkdownContent.module.css";

export type MarkdownContentProps = HTMLAttributes<HTMLDivElement> & {
  brief?: boolean;
  dropcap?: boolean;
};

export const brief = "brief";

const MarkdownContent: FC<MarkdownContentProps> = ({
  className,
  brief = false,
  dropcap = false,
  children,
  ...props
}) => (
  <div
    className={cx(
      classNames.content,
      { [classNames.brief]: brief, [classNames.dropcap]: dropcap },
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

export default MarkdownContent;
